@if (tellentAssistantFlag()) {
  <tlc-app-shell-topbar-button iconName="tellent-hr-assistant-temp" (click)="service.toggle()" />
}
